exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".button-div {\n  border-radius: 10px;\n  background-color: #ef4889;\n  text-transform: uppercase;\n  padding: 16px 40px;\n  text-align: center;\n  color: white;\n  cursor: pointer;\n  transition: transform .08s ease-in-out;\n  box-sizing: border-box; }\n  .button-div:hover {\n    transform: scale(1.1); }\n  .button-div:active {\n    transform: scale(0.9);\n    background-color: #8e0c3f; }\n  .button-div.small {\n    padding: 8px 16px;\n    margin-left: 20px; }\n    .button-div.small .button-text {\n      line-height: 8px; }\n\n.button-text {\n  font-size: 14px;\n  height: auto;\n  font-family: Nunito;\n  font-weight: 900; }\n\n.disabled {\n  background-color: #d8d8d8;\n  cursor: not-allowed; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/components/PrismButton.scss
// module id = 718
// module chunks = 0